import React, { useEffect } from 'react';

import { useHistory, useLocation } from 'react-router-dom';
import { ReactComponent as MapIcon } from "../assets/images/mapIcon.svg";
import { ReactComponent as PartnerIcon } from "../assets/images/partnerIcon.svg";
import { ReactComponent as PlantIcon } from "../assets/images/plantIcon.svg";

const Footer: React.FC = () => {

  let location = useLocation();
  const history = useHistory();
  
    // useEffect(() => {
    // console.log(location.pathname)
    // }, [location]);


  return (
    <>
      {location.pathname !== '/edit' && (
      <footer className="_fill-current _text-white _fixed _bottom-none _bg-darkengreen _shadow-md  _w-full _flex _rounded-t-md _overflow-hidden _z-50" style={{height:'74px'}}>
        <button className={`_w-full _flex _flex-col _justify-center  _rounded-md _m-xxs _items-center ${location.pathname === '/' ? '_ripple-bg-green selected-element' : ''}`} onClick={() => history.push(`/`)}>
          <MapIcon/>
          <span>Carte</span>
        </button >
        <button className={`_w-full _flex _flex-col _justify-center _rounded-md _m-xxs  _items-center  ${location.pathname === '/plants' ? '_ripple-bg-green selected-element' : ''}`} onClick={() => history.push(`/plants`)}>
          <PlantIcon/>
          <span>Plantes</span>
        </button>
        <button className={`_w-full _flex _flex-col _justify-center _rounded-md _m-xxs _items-center  ${location.pathname === '/partners' ? '_ripple-bg-green selected-element' : ''}`} onClick={ () => history.push(`/partners`)}>
          <PartnerIcon/>
          <span>Partenaires</span>
        </button>
        </footer>
      )}
    </>
  );
}

export default Footer;
